import ListItem from "@/components/ListItem";
import SectionHeading from "@/components/SectionHeading";
import type { ExperienceCredits } from "@/types";

interface Props {
  experienceCredits: ExperienceCredits | null;
}

export default function ExperienceCreditsToBeAppliedSection({ experienceCredits }: Props) {
  return (
    <>
      <SectionHeading
        heading="Experience Credits to be Applied"
        body="The following experience credits will be automatically applied upon application approval."
      />
      <div
        className="-mt-2 grid grid-cols-1 md:grid-cols-3 gap-4"
        data-testid="experience-credits-to-be-applied-metrics"
      >
        <ListItem
          iconName="school"
          iconBackground
          overline="Education Credits"
          headline={experienceCredits ? String(experienceCredits.educationCredits) : "--"}
        />
        <ListItem
          iconName="business_center"
          iconBackground
          overline="Employment Credits"
          headline={experienceCredits ? String(experienceCredits.employmentCredits) : "--"}
        />
        <ListItem
          iconName="collections_bookmark"
          iconBackground
          overline="Total Experience Credits"
          headline={experienceCredits ? String(experienceCredits.total) : "--"}
        />
      </div>
    </>
  );
}
